import type { ProductEntity } from '../../domain/entities/Product';
import type { ProductManagementService } from '../../domain/services/ProductManagementService';
import type { UpdateProductDTO } from '../dtos/product/UpdateProductDTO';
import type { ProductResponseDTO } from '../dtos/product/ProductResponseDTO';

export interface UpdateProductUseCase {
  execute(id: string, dto: UpdateProductDTO): Promise<ProductResponseDTO>;
}

export default class UpdateProductUseCaseImpl implements UpdateProductUseCase {
  constructor(
    private readonly productManagementService: ProductManagementService
  ) {}

  async execute(id: string, dto: UpdateProductDTO): Promise<ProductResponseDTO> {
    try {
      const product = await this.productManagementService.updateProduct(id, dto);
      return this.mapToResponseDTO(product);
    } catch (error) {
      throw new Error(`Failed to update product: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  private mapToResponseDTO(product: ProductEntity): ProductResponseDTO {
    const jsonProduct = product.toJSON();
    return {
      id: jsonProduct._id,
      name: jsonProduct.name,
      sku: jsonProduct.sku,
      description: jsonProduct.description,
      barcode: jsonProduct.barcode,
      category: jsonProduct.category,
      cost: jsonProduct.cost,
      price: jsonProduct.price,
      minQuantity: jsonProduct.minQuantity,
      maxQuantity: jsonProduct.maxQuantity,
      isActive: jsonProduct.isActive,
      createdAt: jsonProduct.createdAt,
      updatedAt: jsonProduct.updatedAt
    };
  }
}
